var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('list-view',{attrs:{"headers":_vm.headers,"row-actions":_vm.rowActions,"top-actions":_vm.topActions,"sort-by":"_id","url":"/v4/site/economy/vat-codes","title":"VAT codes"},scopedSlots:_vm._u([{key:"item.account",fn:function(ref){
var item = ref.item;
return [(item.account)?_c('span',[_vm._v(" "+_vm._s(item.account.number)+" - "+_vm._s(item.account.name)+" ")]):_vm._e()]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }